var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, ThemeProvider } from 'styled-components';
import { useEffect } from 'react';
import themeDefault from '../../../landing/components/core/themes/theme';
import { GroupInfoSection } from './GroupInfoSection/GroupInfoSection';
import { StudentsTable } from './Table/StudentsTable';
import { TeacherAssistantsTable } from './Table/AssistantsTable';
import { useGroup } from './hooks/useGroup';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1rh2noz" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 1024px;\n\n  margin: 0 auto;\n"], ["\n  max-width: 1024px;\n\n  margin: 0 auto;\n"])));
var Roster = function (_a) {
    var groupId = _a.groupId, rest = __rest(_a, ["groupId"]);
    var _b = useGroup(groupId), group = _b.group, getGroup = _b.getGroup, updateName = _b.updateName, updateLanguage = _b.updateLanguage, captureError = _b.captureError;
    var isAssistant = group.isAssistant;
    useEffect(function () {
        getGroup();
    }, []);
    useEffect(function () {
        captureError();
    }, [captureError]);
    return (_jsx(ThemeProvider, __assign({ theme: themeDefault }, { children: _jsxs(Container, __assign({}, rest, { children: [_jsx(GroupInfoSection, { data: group, onNameUpdate: updateName, onLanguageUpdate: updateLanguage }, void 0), _jsx(StudentsTable, { groupId: groupId, groupData: group }, void 0), isAssistant === false && (_jsx(TeacherAssistantsTable, { groupId: groupId, groupData: group }, void 0))] }), void 0) }), void 0));
};
export default Roster;
var templateObject_1;
